export const TARS_PROVIDER = 0



// WEBPACK FOOTER //
// ./src/config/config.js